import React from 'react';
import './Distributions.css';

const Distributions: React.FC = () => {
  return (
    <div className="distributions-page">
      <div className="page-header">
        <h1>Distributions</h1>
        <p className="page-description">View distribution declarations and entitlements</p>
      </div>
      <div className="page-content">
        <div className="empty-state">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="1" x2="12" y2="23"></line>
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
          </svg>
          <h2>Coming Soon</h2>
          <p>Distribution management features will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default Distributions;

